// @flow
import React, { PureComponent } from 'react';

import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import DropdownRadioInput from 'components/fragments/input/DropdownRadioInput';
import type { CompetitionEquipeType } from 'types/Settings';

export type StateProps = {
  competitionsEquipes: CompetitionEquipeType,
  competitionsOvale: number[],
  competitionLink: string,
};

export type DispatchProps = {
  fetchSeasons(): void,
};

type OwnProps = {
  competitions: any[],
  searchSuggestions: {
    id: string,
    numeroAffiliation: string,
    nom: string,
    nom_f: string,
    poste: string,
    photo: any
  }[],
  withSeason?: boolean,
  withCompetition?: boolean,
  withSearch?: boolean,
  withLink?: boolean,
  onSeasonChange: (value: string) => void,
  onCompetitionChange: (value: number[]) => void,
  selectedCompetitions: number[],
  onSearch: (value: string) => void,
  onSearchSuggestClick: (value: string) => void,
  className?: string,
  separatorClass: string,
  placeholderSearch?: string,
  seasons: Array<{ id: string, nom: string }>,
  selectedSeason: string,
  searchValue: string,
};

type State = {
  setDefaultComp: boolean,
}

type Props = OwnProps & StateProps & DispatchProps;

class TeamFilter extends PureComponent<Props, State> {
  static defaultProps: OwnProps = {
    currentSeason: {
      nom: "",
      id: "",
    },
    seasons: [],
    withCompetition: false,
    withLink: false,
    withSeason: false,
    competitions: [
    ],
    searchSuggestions: [],
    className: '',
    separatorClass: 'header-filter__sep mb-1',
    selectedCompetitions: [],
    onSeasonChange: (value: string) => { },
    onCompetitionChange: (value: number[]) => { },
    onSearch: (value: string) => { },
    onSearchSuggestClick: (value: string) => { },
    placeholderSearch: "Saisir le nom d'un joueur",
    selectedSeason: "",
    searchValue: '',
  };

  componentDidMount() {
    const { fetchSeasons } = this.props;

    fetchSeasons();
  }

  state = {
    setDefaultComp: false,
  };

  _convertSeasonsToOptions = () => {
    const { seasons } = this.props;

    return seasons.map<any>((season) => ({ label: season.nom, value: parseInt(season.id, 10) }));
  };

  _convertCompetitionsToOptions = () => {
    const { competitions } = this.props;

    return competitions.map<any>((competition) => ({
      label: competition.nom,
      value: parseInt(competition.id, 10)
    }));
  };

  _renderSeasonsFilter = () => {
    const { onSeasonChange, selectedSeason } = this.props;
    const saisonsOptions = this._convertSeasonsToOptions();
    const currentSeason = saisonsOptions.find(({ value }) => value.toString() === selectedSeason.toString());

    if (!onSeasonChange || !saisonsOptions || saisonsOptions.length === 0) {
      return null;
    }

    return (
      <DropdownRadioInput
        prelabel={currentSeason ? "Saison " : ""}
        label={currentSeason ? currentSeason.label : "Veuillez choisir une saison"}
        id="Saisons"
        options={saisonsOptions}
        inputChanged={onSeasonChange}
        noBorder
        maj
        title
        isPreLabelThin={false}
      />
    );
  };

  handleCompetitionsChange = (value: string) => {
    const { onCompetitionChange, selectedCompetitions: oldCompets } = this.props;
    const valueToInt = parseInt(value, 10);

    if (oldCompets.includes(valueToInt)) {
      onCompetitionChange(oldCompets.filter(comp => comp !== valueToInt));
    } else {
      onCompetitionChange(oldCompets.concat(valueToInt));
    }
  };

  _renderCompetitionsFilter = () => {
    const { selectedCompetitions } = this.props;

    return (
      <div className="multi-dropdown">
        <DropdownMultiInput
          className="dropdown dropdown--noBorder dropdown--checkbox"
          selected={selectedCompetitions}
          label="Toutes les compétitions"
          counter={0}
          inputChanged={this.handleCompetitionsChange}
          id="ssddf_undefined"
          options={this._convertCompetitionsToOptions()}
          closeOnSelect={false}
        />
      </div>
    );
  };

  _renderLink = () => {
    const { competitionsEquipes, competitionsOvale } = this.props;

    if (
      Object.keys(competitionsEquipes).length > 0
      && competitionsOvale.length > 0
    ) {
      return (
        <div className="header-filter__right">
          <a
            href={'https://competitions.ffr.fr'}
            target="_blank"
            rel="noopener noreferrer"
            className="link-chevron"
          >
            <span>Accédez au site compétitions ffr.fr</span>
            <i className="icon icon-chevron-right" />
          </a>
        </div>
      );
    }

    return null;
  };

  _handleSearch = (e: SyntheticInputEvent<EventTarget>) => {
    const { onSearch } = this.props;
    const { value } = e.target;
    onSearch(value);
  };

  _handleClickSuggestion = (e: SyntheticInputEvent<EventTarget>) => {
    const { onSearchSuggestClick } = this.props;
    const { innerHTML } = e.target;
    onSearchSuggestClick(innerHTML);
  };

  _renderSearchFilter = () => {
    const { searchSuggestions, placeholderSearch, searchValue } = this.props;
    console.log(searchSuggestions);
    return (
      <form>
        <div className="input input--dropdown">
          <input
            type="search"
            id="ois38234"
            placeholder={placeholderSearch}
            autoComplete='off'
            value={searchValue}
            onChange={this._handleSearch} />
          <label htmlFor="ois38234">{placeholderSearch}</label>
          <div className="dropdown__list">
            <div className="dropdown__wrapper">
              {searchSuggestions
                .filter(({nom}) =>  searchValue ? nom.toLowerCase().includes(searchValue.toLowerCase()) : true)
                .map(({ id, nom }) => (
                <p
                  key={`${id}_${nom}`}
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                  role='button'
                  tabIndex={0}
                  onClick={this._handleClickSuggestion}>
                  {nom}
                </p>
              )
              )}
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const {
      withLink,
      withCompetition,
      withSeason,
      withSearch,
      className,
      separatorClass,
    } = this.props;

    return (
      <>
        <div className={className}>
          <div className="row">
            <div className="col col-lg-8on9">
              <div className="header-filter__left" style={{ minHeight: '48px' }}>
                {withSeason && this._renderSeasonsFilter()}
                {withCompetition && this._renderCompetitionsFilter()}
              </div>
              <div className="header-filter__right">
                {withSearch && this._renderSearchFilter()}
              </div>
              {withLink && this._renderLink()}
            </div>
          </div>
        </div>
        <div className={separatorClass}></div>
      </>
    );
  }
}

export default TeamFilter;
